import { NotificationService } from '@aiz-gl/omni-ui';
import { computed, effect, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  auth = inject(AuthService);
  notifications = inject(NotificationService);

  navigationEnd = toSignal(
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)),
    {},
  );

  routeData = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute.root;
        // Traverse to the deepest child to get the active route's data
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      mergeMap((route) => route.data),
    ),
  );

  hideNavigation = computed(() => {
    const data = this.routeData();
    return data ? data['hideNavigation'] : true;
  });

  constructor() {
    // Hide any alert that may be showing when navigating away from a page.
    effect(() => {
      if (this.navigationEnd()) this.notifications.hideAlert();
    });
  }
}
